// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__ByWf0","header":"PatientBlock_header__7uwdl","label":"PatientBlock_label__2IP9k","option":"PatientBlock_option__qNpiF"};